import Vue from "vue";
// import * as L from "leaflet";
import _ from "lodash";
import API from "@/api/index";
import Lane from "@/models/Lane";

const MODULE_NAME = "intersection";

const MUTATION_TYPES = {
	UPDATE_INTERSECTION: "UPDATE_INTERSECTION",
	UPDATE_LANES: "UPDATE_LANES"
};

const ACTION_TYPES = {
	LOAD_INTERSECTION: "LOAD_INTERSECTION",
	LOAD_LANES: "LOAD_LANES"
};

let retryCount = 0;

export default {
	MODULE_NAME,
	MUTATION_TYPES,
	ACTION_TYPES,
	namespaced: true,
	state: {
		intersections: {}
	},
	mutations: {
		[MUTATION_TYPES.UPDATE_INTERSECTION](state, payload) {
			if (!(payload && _.isObject(payload))) {
				throw new Error(
					`${MODULE_NAME}/${MUTATION_TYPES.UPDATE_INTERSECTION}: Invalid or missing payload.`
				);
			}
			const data =
				(!_.isUndefined(payload.intersection) && payload.intersection) ||
				(!_.isUndefined(payload.data) && payload.data) ||
				payload;
			const intersectionId =
				data.intersectionid ||
				data.intersectionId ||
				data.IntersectionId ||
				payload.intersectionId ||
				payload.IntersectionId ||
				payload.id;
			if (!intersectionId) {
				throw new Error(
					`${MODULE_NAME}/${MUTATION_TYPES.UPDATE_INTERSECTION}: Invalid or missing intersection id.`
				);
			}
			Vue.set(state.intersections, intersectionId, data);
		},
		[MUTATION_TYPES.UPDATE_LANES](state, payload) {
			if (!(payload && _.isObject(payload))) {
				throw new Error(
					`${MODULE_NAME}/${MUTATION_TYPES.UPDATE_INTERSECTION}: Invalid or missing payload.`
				);
			}

			const intersectionId = payload["intersectionId"];
			const lanes = _.map(payload["lanes"], lane => new Lane(lane));
			Vue.set(state.intersections, intersectionId, {
				...state.intersections[intersectionId],
				lanes
			});
		}
	},
	actions: {
		[ACTION_TYPES.LOAD_INTERSECTION](context, payload) {
			const intersectionId = parseInt(
				_.isObject(payload)
					? payload.intersectionid ||
							payload.intersectionId ||
							payload.IntersectionId ||
							payload.id
					: payload,
				10
			);
			return new Promise((resolve, reject) => {
				if (!intersectionId) {
					return reject(
						new Error(
							`${MODULE_NAME}/${ACTION_TYPES.LOAD_INTERSECTION}: Invalid or missing intersection id.`
						)
					);
				}
				if (_.isUndefined(context.getters.byIdentifier(intersectionId))) {
					// Hit API
					return resolve(
						API.getWithParamsJson(
							API.ENDPOINTS.SELECT_INTERSECTION_BY_INTERSECTION_ID,
							{ intersectionId },
							{},
							e => {
								throw e;
							}
						)
					);
				} else {
					return resolve(context.getters.byIdentifier(intersectionId));
				}
			})
				.then(result => {
					if (_.isEmpty(result)) {
						throw new Error(
							`${MODULE_NAME}.${ACTION_TYPES.LOAD_INTERSECTION}: Falsy server response for intersectionId "${intersectionId}".`
						);
					}
					return result;
				})
				.catch(e => {
					console.warn(e);
					return { intersectionId, intersection: null };
				})
				.then(result => {
					if (_.isArray(result)) result = result[0];
					try {
						context.commit(`${MUTATION_TYPES.UPDATE_INTERSECTION}`, result);
					} catch (e) {
						console.warn("LOAD_INTERSECTION", e, intersectionId, result);
					}
					return context.getters.byIdentifier(intersectionId);
				});
		},
		// Payload is intersection id as int.
		async [ACTION_TYPES.LOAD_LANES](context, intersectionId) {
			if (typeof intersectionId != "number" || intersectionId < 0) {
				return Promise.reject(
					"Invalid payload. Payload must be intersection id as an integer."
				);
			}

			// If intersection hass not previously been loaded
			// then first load intersection requested.
			if (!context.state.intersections[intersectionId]) {
				await context.actions.ACTION_TYPES.LOAD_INTERSECTION(intersectionId);
			}

			const maxRetries = 5;
			const retryInterval = 1000;
			try {
				return API.getWithParamsJson(
					API.ENDPOINTS.GET_LANES_BY_INTERSECTION_ID,
					{ intersectionId },
					{},
					error => Promise.reject(error)
				)
					.then(data => {
						retryCount = 0;
						context.commit(`${MUTATION_TYPES.UPDATE_LANES}`, {
							intersectionId,
							lanes: data
						});
					})
					.catch(error => console.error(error));
			} catch (e) {
				console.warn(e);
				if (retryCount < maxRetries) {
					retryCount++;
					setTimeout(
						() => context.actions(`${ACTION_TYPES.LOAD_LANES}`, intersectionId),
						retryInterval
					);
				}
			}
		}
	},
	getters: {
		all(state) {
			return state.intersections;
		},
		byIdentifier(state) {
			return intersectionId => state.intersections[intersectionId];
		}
	}
};
